import { useGetCommon, type PhotoFeedResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { Flex, Spinner } from "@chakra-ui/react";
import { CustomBox, CustomCenter } from "./photoFeed.style";

export const PhotoFeed = () => {
    const { data } = useGetCommon<PhotoFeedResponse>({ section: "photos" });
    const { isMobile } = MEDIA();
    const { idx } = getDefaultParameters();

    const isGogo = idx === "2017";
    const firstText = data?.imgList.filter((_, index) => index === 0) || [];
    const imgUrls = data?.imgList.filter((it) => it.imgUrl) || [];

    const gogoDinoArr = firstText.concat(imgUrls);

    return data ? (
        <CustomBox w="100%" boxSizing="border-box">
            <Flex overflow="auto" alignItems="center" h={isMobile ? "280px" : "480px"}>
                {isGogo
                    ? gogoDinoArr.map((img, idx) => (
                          <CustomCenter
                              key={img[idx]}
                              w={isMobile ? "320px" : "640px"}
                              isText={img.text}
                              isLogo={img.logoUrl}
                              flexShrink={0}
                              background={`url(${img.imgUrl ?? img.logoUrl}) no-repeat center/${img.imgUrl ? "cover" : "contain"}`}
                          >
                              {img.text ?? ""}
                          </CustomCenter>
                      ))
                    : data.imgList.map((img, idx) => (
                          <CustomCenter
                              key={img[idx]}
                              w={isMobile ? "320px" : "640px"}
                              isText={img.text}
                              isLogo={img.logoUrl}
                              flexShrink={0}
                              background={`url(${img.imgUrl ?? img.logoUrl}) no-repeat center/${img.imgUrl ? "cover" : "contain"}`}
                          >
                              {img.text ?? ""}
                          </CustomCenter>
                      ))}
            </Flex>
        </CustomBox>
    ) : (
        <Spinner />
    );
};
